<template>
  <a-drawer
    :visible="visible"
    title="预览预病历"
    placement="right"
    :width="730"
    @close="handleDrawerClose"
    class="PreviewDrawer-drawer"
  >
    <a-spin :spinning="loading">
      <div class="preview-modal">
        <div class="preview">
          <!-- 基础信息 -->
          <div class="preview__card">
            <!-- 顶部状态条：根据审核状态 + 购买状态展示不同图标与文案 -->
            <div :class="['record-State', { 'record-state-wrap': isPurchased }]">
              <div>
                <check-circle-filled v-if="isPurchased" />
                <exclamation-circle-filled v-else />
                <span class="tips">{{ recordStateTips }}</span>
              </div>
              <div v-if="preMedicalRecord.recordState === 1">
                <a-button type="link" v-if="!isPurchased" @click="handleViewPaymentQrCode">
                  查看支付二维码
                </a-button>
                <a-button type="link" @click="handleViewTreatmentPlan">查看治疗方案</a-button>
              </div>
            </div>
            <div class="preview__info base-info">
              <div class="preview__info-item">
                <span class="label">患者姓名：</span>
                <span class="content">{{ preMedicalRecord.patientName || '-' }}</span>
              </div>
              <div class="preview__info-item">
                <span class="label">性别：</span>
                <span class="content">{{ patientGender }}</span>
              </div>
              <div class="preview__info-item">
                <span class="label">年龄：</span>
                <span class="content">
                  {{ preMedicalRecord.patientAge != null ? preMedicalRecord.patientAge : '-' }}
                </span>
              </div>
            </div>
            <div class="preview__info base-info">
              <div class="preview__info-item">
                <span class="label">医生姓名：</span>
                <span class="content">
                  {{ preMedicalRecord.doctorName || '-' }}
                </span>
              </div>
            </div>
          </div>
          <!-- 预问诊小结 -->
          <div class="preview__card">
            <div class="preview__title">预问诊小结</div>
            <div
              class="preview__info summary-info"
              v-if="preMedicalRecord.advanceConsultationSummaryVO"
            >
              <div class="preview__info-item">
                <span class="label">用药状态：</span>
                <span class="content">
                  {{
                    medicationStatusMap[
                      preMedicalRecord.advanceConsultationSummaryVO.medicationStatus
                    ]?.label || '--'
                  }}
                </span>
              </div>
              <div class="preview__info-item">
                <span class="label">用药清单：</span>
                <span class="content">
                  <template
                    v-if="
                      preMedicalRecord.advanceConsultationSummaryVO.medicationSituation &&
                      preMedicalRecord.advanceConsultationSummaryVO.medicationSituation.length
                    "
                  >
                    <div
                      :key="item"
                      v-for="item in preMedicalRecord.advanceConsultationSummaryVO
                        .medicationSituation"
                    >
                      {{ item }}
                    </div>
                  </template>
                  <template v-else>暂无</template>
                </span>
              </div>
              <div class="preview__info-item">
                <span class="label">用药说明：</span>
                <span class="content">
                  {{
                    preMedicalRecord.advanceConsultationSummaryVO
                      ?.medicationSupplementDescribeStr || '暂无'
                  }}
                </span>
              </div>
            </div>
            <div class="preview__empty" v-else>暂无</div>
          </div>
          <!-- 诊断 -->
          <div class="preview__card">
            <div class="preview__info">
              <div class="preview__info-item">
                <span class="label">诊断：</span>
                <span class="content">{{ diagnosis }}</span>
              </div>
              <div
                class="preview__info-item"
                v-if="preMedicalRecord.chineseDiagnoses && preMedicalRecord.chineseDiagnoses.length"
              >
                <span class="label">中医证型：</span>
                <span class="content">
                  {{ diagnosisType }}
                </span>
              </div>
              <div class="preview__info-item" v-if="preMedicalRecord.remark">
                <span class="label">备注：</span>
                <span class="content">
                  {{ preMedicalRecord.remark || '--' }}
                </span>
              </div>
              <div class="preview__info-item" v-if="preMedicalRecord.mainComplaint">
                <span class="label">主诉：</span>
                <span class="content">
                  {{ preMedicalRecord.mainComplaint || '--' }}
                </span>
              </div>
            </div>
            <!-- <div class="preview__empty" v-else>暂无</div> -->
          </div>
          <!-- 药品/健康用品 -->
          <div class="preview__card">
            <div class="preview__title">药品/健康用品</div>
            <div class="preview__info" v-if="(preMedicalRecord.medicineDetailVOList || []).length">
              <div
                class="sku-item"
                v-for="sku in preMedicalRecord.medicineDetailVOList"
                :key="sku.skuCode"
              >
                <span class="left">{{ sku.skuName }}</span>
                <span class="right">
                  <span class="x-unit">X</span>
                  {{ sku.quantity }}
                </span>
              </div>
            </div>
            <div class="preview__empty" v-else>暂无</div>
          </div>
          <!-- 治疗费用 -->
          <div class="preview__card">
            <div class="preview__info treatment-cost">
              <div class="preview__info-item">
                <span class="label">诊后病程服务费</span>
                <span
                  class="content text-right"
                  v-if="preMedicalRecord.postServiceFee"
                  @click="openServiceFeeModal"
                >
                  <!--                  {{ '¥' + preMedicalRecord.postServiceFee ?? '-' }}-->
                  <!-- <right-outlined class="icon" /> -->
                  <img width="20" height="20" src="@/assets/img/right-icon.png" alt="/" />
                </span>
              </div>
            </div>
          </div>
          <!-- 预约复诊 -->
          <div class="preview__card">
            <div class="preview__title">预约复诊</div>
            <div class="revisitSummary-item">{{ revisitSummary }}</div>
          </div>
          <div class="preview__card" v-if="entrust">
            <div class="preview__title">嘱托</div>
            <div class="revisitSummary-item">{{ entrust || '--' }}</div>
          </div>
          <!-- 合计价格 -->
          <div class="preview__card">
            <div class="preview__title">合计价格</div>
            <div class="amount-table">
              <div class="line top">
                <div class="cell">诊疗费</div>
                <div class="cell">医药费</div>
                <div class="cell">合计</div>
              </div>
              <div class="line bottom">
                <div class="cell">
                  {{
                    preMedicalRecord.cureServiceAmount
                      ? '¥' + preMedicalRecord.cureServiceAmount
                      : '免费'
                  }}
                </div>
                <div class="cell">{{ '¥' + preMedicalRecord.medicineAmount }}</div>
                <div class="cell">{{ '¥' + preMedicalRecord.summationAmount }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </a-spin>
  </a-drawer>

  <ServiceFeeModal
    v-model:visible="serviceFeeVisible"
    :postService-fee="preMedicalRecord.postServiceFee"
    :egg-gold-amount="preMedicalRecord.eggGoldAmount"
    :equityInfo-list="preMedicalRecord.equityInfoList"
    :uc-doctor-id="serviceFeeDoctorId"
    :policy-fee="serviceFeePolicyFee"
    :service-package-code="servicePackageCode"
    @cancel="closeServiceFeeModal"
    @ok="closeServiceFeeModal"
  />

  <a-modal
    v-model:visible="paymentQrVisible"
    title="支付二维码"
    :footer="null"
    centered
    width="360px"
  >
    <img class="payment-qr-image" :src="paymentQrCodeUrl" alt="支付二维码" />
  </a-modal>

  <TheDetail
    v-model:visible="treatmentPlanVisible"
    :serialNumber="treatmentPlanSerialNumber"
    :recordType="treatmentPlanRecordType"
    mode="read"
  />
</template>

<script setup>
import { computed, ref, defineExpose, reactive } from 'vue'
import { medicationStatusMap } from './config'
import moment from 'moment'
import ServiceFeeModal from './ServiceFeeModal.vue'
import { getMedicalRecordById } from '@/api/HealthRecord/index.js'
import { patientGenderMap } from './config'
import { ExclamationCircleFilled, CheckCircleFilled } from '@ant-design/icons-vue'
import TheDetail from '@/components/TheDetail/index.vue'
import { subStringToType } from '@/utils/index'
import { message } from 'ant-design-vue'
import QRCode from 'qrcode'

const recordStateMap = {
  0: '待医生确认｜请提醒医生至【医生端-预病历待办】中审核',
  1: '待购买｜请提醒患者及时购买',
  2: '医生已驳回',
  3: '已失效'
}

// 处方购买状态映射：0未购 1部分购买 2全部购买 3已下单未支付
const buyStateMap = {
  0: '患者未购买',
  1: '患者已部分购买',
  2: '患者已购买',
  3: '患者已下单未支付'
}

const patientGender = computed(() => {
  return patientGenderMap[preMedicalRecord.patientGender]?.label || '未知'
})

// 审核通过且有购买行为（部分/全部）时，状态条切换为成功图标
const isPurchased = computed(() => {
  const buyState = Number(preMedicalRecord.buyState)
  return preMedicalRecord.recordState === 1 && [1, 2].includes(buyState)
})

// 状态条文案优先展示购买状态，其余场景沿用预病历状态文案
const recordStateTips = computed(() => {
  if (isPurchased.value) {
    return buyStateMap[preMedicalRecord.buyState] || '-'
  }
  return recordStateMap[preMedicalRecord.recordState] || '-'
})
// 预病历数据源
const preMedicalRecord = reactive({})
// 弹窗展示
const visible = ref(false)
// 抽屉内容加载态
const loading = ref(false)
// 服务费弹窗显隐
const serviceFeeVisible = ref(false)
// 支付二维码弹窗显隐
const paymentQrVisible = ref(false)
// 支付二维码地址
const paymentQrCodeUrl = ref('')
// 治疗方案弹窗显隐
const treatmentPlanVisible = ref(false)
// 治疗方案编号
const treatmentPlanSerialNumber = ref('')
// 治疗方案记录类型
const treatmentPlanRecordType = ref('')
// 服务费弹窗 doctorId
const serviceFeeDoctorId = computed(
  () => preMedicalRecord?.ucDoctorId ?? preMedicalRecord?.ucDoctorId ?? null
)
// 嘱托合并展示
const entrust = computed(() => {
  const taboo = preMedicalRecord.taboo || ''
  const advice = preMedicalRecord.advice || ''
  return [taboo, advice].filter(Boolean).join('；')
})

// 复诊时段文案
const revisitDetailText = computed(() => {
  const value = preMedicalRecord.revisitInfoVO?.reserveDateDetail
  if (value === 1) return '上午'
  if (value === 2) return '下午'
  return '-'
})

// 复诊方式文案
const revisitTypeText = computed(() => {
  const value = preMedicalRecord.revisitInfoVO?.revisitType
  if (value === 1) return '线上咨询'
  if (value === 2) return '门诊就诊'
  return '-'
})

// 复诊信息汇总文案
const revisitSummary = computed(() => {
  const infoValue = preMedicalRecord.revisitInfoVO || {}
  if (infoValue.notNeedReserve) return '遵医嘱复诊'
  const reserveDate = infoValue.reserveDate
  if (!reserveDate) return '-'
  const date = moment(reserveDate).format('YYYY-MM-DD')
  const day = moment(reserveDate).format('dddd')
  const detail = revisitDetailText.value
  return `${date} ${day} ${detail} ｜ ${revisitTypeText.value}`
})
// 诊断（合并展示）
const diagnosis = computed(() => {
  if (!preMedicalRecord.westernDiagnoses) return '--'
  const text = preMedicalRecord.westernDiagnoses.map(m => m.name).join(';')
  return text || '--'
})
// 中医证型（合并展示）
const diagnosisType = computed(() => {
  if (!preMedicalRecord.chineseDiagnoses) return '--'
  const text = preMedicalRecord.chineseDiagnoses.map(m => m.name).join(';')
  return text || '--'
})

// 打开服务费弹窗
const openServiceFeeModal = () => {
  serviceFeeVisible.value = true
}

// 关闭服务费弹窗
const closeServiceFeeModal = () => {
  serviceFeeVisible.value = false
}

// 读取 codeUrl 并生成二维码图片，在弹窗内展示
const handleViewPaymentQrCode = async () => {
  const paymentUrl = preMedicalRecord.codeUrl || ''
  if (!paymentUrl) {
    message.warning('暂无支付二维码')
    return
  }
  try {
    paymentQrCodeUrl.value = await QRCode.toDataURL(paymentUrl, {
      width: 320,
      margin: 1
    })
    paymentQrVisible.value = true
  } catch (error) {
    message.error('二维码生成失败')
  }
}

const handleViewTreatmentPlan = () => {
  const serialNumber =
    preMedicalRecord.parentInstanceSn || preMedicalRecord.parentSerialNumber || ''
  if (!serialNumber) {
    message.warning('暂无治疗方案')
    return
  }
  treatmentPlanSerialNumber.value = serialNumber
  treatmentPlanRecordType.value = subStringToType(serialNumber)
  treatmentPlanVisible.value = true
}

const resetPreMedicalRecord = () => {
  Object.keys(preMedicalRecord).forEach(key => {
    delete preMedicalRecord[key]
  })
}

const handleDrawerClose = () => {
  visible.value = false
  loading.value = false
  serviceFeeVisible.value = false
  paymentQrVisible.value = false
  paymentQrCodeUrl.value = ''
  treatmentPlanVisible.value = false
  treatmentPlanSerialNumber.value = ''
  treatmentPlanRecordType.value = ''
  resetPreMedicalRecord()
}
//弹窗初始化 id 为预病历id
const initModal = async id => {
  loading.value = true
  try {
    visible.value = true
    const res = await getMedicalRecordById({ id })
    resetPreMedicalRecord()
    Object.assign(preMedicalRecord, res || {})
    loading.value = false
  } catch (error) {
    console.log('获取病历详情异常：', error)
  }
}
defineExpose({
  initModal
})
</script>
<style>
.PreviewDrawer-drawer .ant-drawer-body {
  margin-bottom: 0;
  padding: 0;
  height: calc(100% - 55px);
}
</style>
<style scoped lang="scss">
.preview-modal {
  position: relative;
  height: 100%;
  .preview {
    height: calc(100% - 55px);
    overflow-y: auto;
  }
  .preview-modal__footer {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 100%;
    border-top: 1px solid #e9e9e9;
    padding: 10px 16px;
    background: #fff;
    text-align: right;
    z-index: 1;
  }
}

.preview__card {
  border-top: 1px solid #ebebeb;
  padding: 20px 20px 0;
  margin-bottom: 20px;
  .record-State {
    padding: 12px 16px;
    background: #fff7ee;
    color: #ff992b;
    font-weight: 500;
    font-size: 14px;
    border-radius: 8px;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .tips {
      margin-left: 8px;
    }
  }
  .record-state-wrap {
    background: #f2fbed;
    color: #52c41a;
  }
  &:first-child {
    border: none;
  }
}
// 通用
.preview__info {
  .preview__info-item {
    margin-bottom: 20px;
    display: flex;
    .label {
      color: #999999;
      font-size: 14px;
      font-weight: 500;
      width: 75px;
      text-align: right;
    }
    .content {
      flex: 1;
      color: #333333;
      font-size: 14px;
      font-weight: 500;
      text-align: left;
    }
  }
}
// 基础信息
.base-info {
  display: flex;
  margin-bottom: 24px;
  &:last-child {
    margin-bottom: 0;
  }
  .preview__info-item {
    padding-right: 48px;
    border-right: 1px solid #e8e8e8;
    margin-left: 16px;
    margin-bottom: 0;
    &:last-child {
      border-right: none;
    }
    &:first-child {
      margin-left: 0;
    }
  }
}
// 小结
.summary-info {
  display: block;
}
// 药品/健康用品 sku-item
.sku-item,
.revisitSummary-item {
  background: #fafafa;
  padding: 12px;
  font-size: 16px;
  color: #333333;
  margin-bottom: 12px;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  &:last-child {
    margin-bottom: 0;
  }
  .right {
    color: #666;
    .x-unit {
      font-size: 12px;
    }
  }
}
.treatment-cost {
  .preview__info-item {
    display: flex;
    justify-content: space-between;
    .label {
      font-weight: 500;
      font-size: 16px;
      color: #333333;
      width: auto;
    }
    .content {
      color: #333333;
      font-size: 16px;
      font-weight: 500;
      text-align: left;
    }
    .text-right {
      cursor: pointer;
      text-align: right;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
  }
}
// 合计费用
.amount-table {
  border: 1px solid #e3e3e3;
  border-radius: 4px;
  overflow: hidden;
  .line {
    font-size: 14px;
    display: flex;
    .cell {
      width: 33.3333%;
      padding: 8px 16px;
      border-right: 1px solid #e3e3e3;
      font-weight: 400;
      &:last-child {
        border-right: none;
      }
      .original-price {
        font-weight: 400;
        font-size: 12px;
        color: #999999;
        margin-left: 2px;
        text-decoration: line-through;
      }
    }
  }
  .top {
    background: #fafafa;
    color: #666666;
    border-bottom: 1px solid #e3e3e3;
  }
  .bottom {
    background-color: white;
  }
}
.preview__title {
  font-weight: 500;
  font-size: 16px;
  color: #333333;
  margin-bottom: 16px;
}

.preview__value {
  font-size: 13px;
  color: #333;
  line-height: 20px;
}

.preview__empty {
  font-size: 12px;
  color: #999;
}

.preview__list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.preview__list-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 10px;
  background: #fafafa;
  border-radius: 6px;
  font-size: 13px;
  color: #333;
}

.preview__list-qty {
  color: #666;
}

.payment-qr-image {
  width: 100%;
  display: block;
}
</style>
